exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin_indexes_page .VueTables__table {\n  table-layout: fixed;\n}\n#admin_indexes_page #index_modal label {\n  font-weight: 500;\n}\n#admin_indexes_page #index_modal .pretty.p-default input:checked ~ .state label::after {\n  background-color: #36a8cd !important;\n}\n#admin_indexes_page #index_modal .pretty.p-switch input:checked ~ .state label::after {\n  background-color: #36a8cd !important;\n}", ""]);

// exports
